import React from "react";
// import { Typography } from "@mui/material";
import SelectedMessageDetails from "../SelectedMessage/SelectedMessageDetails";
import classes from "./SelectedMessagesPrint.module.css";
/**
 *
 * @param {Array} messages Array of messages to be printed
 * @returns
 */
const SelectedMessagesPrint = React.forwardRef(({ messages }, ref) => {
  return (
    <div ref={ref} className={classes.root}>
      {messages.length
        ? messages.map((message, index) => {
            const details = [];
            [...message.detail.details].forEach((detail) => {
              const index = details.findIndex(
                (messageDetail) => messageDetail.title === detail.title
              );
              if (index === -1) details.push(detail);
            });

            const messageDetails = [
              {
                title: message.detail.header.title,
                data: [
                  { key: "Category", value: message.detail.header.category },
                  { key: "Type", value: message.detail.header.messageType },
                  { key: "Way", value: message.detail.header.messageStatus },
                ],
              },
              ...details.sort((a, b) => a.title.localeCompare(b.title)),
            ];
            return (
              <div key={message.header.referenceNumber} className="message">
                <SelectedMessageDetails
                  messageDetails={messageDetails}
                  referenceNumber={message.header.referenceNumber}
                  isPrinting={true}
                />
                {index !== messages.length - 1 ? (
                  <div className={classes["page-break"]} />
                ) : null}
              </div>
            );
          })
        : null}
    </div>
  );
});

export default SelectedMessagesPrint;
